import { Navigate, Outlet, useLocation } from "react-router-dom";

import { isAuthenticated } from "@/services/token";

import { ROUTES } from "./routes";

export function ProtectedRoute() {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to={`/${ROUTES.LOGIN}`} state={{ from: location }} replace />;
  }

  return <Outlet />;
}

export function GuestRoute() {
  if (isAuthenticated()) {
    return <Navigate to={ROUTES.PROFILE} replace />;
  }

  return <Outlet />;
}
